import { KebabCase } from 'type-fest';
import { reduce, kebabCase } from 'lodash';

import {
    IBettingPalette,
    DEFAULT_PALETTE,
    PaletteCssVariables,
    СssSetNaming,
} from 'styles';
import convertHexToRgb from './convertHexToRgb';
import isValidCssPair from './isValidCssPair';

function getPaletteCssVariables(
    Palette: Partial<IBettingPalette>
): PaletteCssVariables {
    return reduce(
        { ...DEFAULT_PALETTE, ...Palette },
        (acc, hex, key: keyof IBettingPalette) => {
            const validationError = isValidCssPair({
                naming: СssSetNaming.PALETTE,
                key,
                value: hex,
            });

            if (validationError) {
                console.error(validationError);

                return acc;
            }

            const cssProp = `--${
                kebabCase(key) as KebabCase<typeof key>
            }` as const;
            const cssPropRgb = `${cssProp}-rgb` as const;
            const rgb = convertHexToRgb(hex);

            acc[cssProp] = hex;

            if (rgb instanceof Error) {
                console.error(rgb);
            } else {
                const { red, green, blue } = rgb;

                acc[cssPropRgb] = `${red}, ${green}, ${blue}` as const;
            }

            return acc;
        },
        {} as PaletteCssVariables
    );
}

export default getPaletteCssVariables;
